import type { RouteRecordRaw } from "vue-router";

export const routes = [
  {
    path: "/counters/:id/:brand?",
    name: "S1 Counter",
    component: () => import("./s1Counter.vue"),
  },
] satisfies RouteRecordRaw[];
